import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import ReportingControls from './ReportingControls';
import ExportMenu from './ExportMenu';
import UnitSwitch from './UnitSwitch';
import PlanVersionPicker from './PlanVersionPicker';
import { usePageExports } from '../exports/pageExports';
import { usePageUnit } from '../exports/pageUnit';
import './PageBar.css';

/* BANDE DE CONTEXTE DE LA PAGE (2026-09-17) — le statut du réel, l'exercice,
   l'unité et la sortie : « quand je lis, comment je compte, comment je sors ».
   Elle appartient au CADRE : rendue une fois par `AppShell`, jamais reproduite
   dans un écran. Une section qui veut y poser son unité la déclare au registre
   `pageUnit`, comme elle déclare ses exports.

   ELLE SE POSE SUR LA LIGNE DU TITRE (2026-09-18), par portail, quand la page
   en offre une : elle occupait sinon un étage de 56 px avant la première
   donnée, et le titre de la page tombait bien plus bas que celui du module
   dans le menu, à côté. Sans entête (les hubs à onglets, dont le titre vit sur
   la ligne d'onglets), elle garde sa place au-dessus du contenu.

   La DATE DU JOUR et la semaine ISO en sont parties le même jour : elles
   n'entrent dans aucune décision, et le système les affiche déjà. Le statut du
   réel, lui, RESTE accolé à l'exercice (demande d'Olivier) : sur un écran qui
   ne porte pas d'arrêté, plus rien ne dirait où en est la clôture. */
export default function PageBar({ hostKey = null }) {
  const pageExports = usePageExports();
  const unit = usePageUnit();
  /* Le nœud d'accueil se cherche APRÈS le rendu du contenu et se rejoue à
     chaque page : une page à onglets n'en offre pas, et la bande revient alors
     d'elle-même au-dessus du contenu. */
  const [host, setHost] = useState(null);
  /* Sans dépendance : la page se REMONTE aussi sans changer de clé (changement
     de version de plan, 2026-09-27), et son nœud d'accueil est alors neuf. Le
     même nœud reposé ne rend rien de plus : React ignore un état inchangé. */
  useLayoutEffect(() => { setHost(document.getElementById('lk-pagebar')); });
  const bar = (
    /* ORDRE de gauche à droite (demande d'Olivier, 2026-09-27, revu le
       2026-09-30) : la version de plan, l'exercice, l'unité, puis la sortie.
       Ce qui CHANGE LES CHIFFRES ressort (la version, l'exercice en gras) ; la
       préférence d'unité se lit en texte discret. Le statut du réel et le mode
       Manuel | Pro sont montés dans la barre supérieure : une information et
       un réglage du client, pas des commandes de la page. */
    <div className={`page-bar${host ? ' page-bar--inline' : ''}`}>
      <PlanVersionPicker />
      <ReportingControls />
      {unit && <UnitSwitch value={unit.value} onChange={unit.onChange} />}
      <ExportMenu options={pageExports} />
    </div>
  );
  return host ? createPortal(bar, host) : bar;
}
